export default class GeometryTypeMapLibre {

  static POINT = 'circle';

  static LINE = 'line';

  static POLYGON = 'fill';
}
